import React, { Component} from "react";
import $ from "jquery";
import * as LocalConfig from "./local_config";
import Loadingicon from "./loading_icon";



class Homepage extends Component {  

   state = {
    dialog:{
      status:false,
      msg:""
    }
  };

  componentDidMount() {
    var reqObj = {};
    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(reqObj)
    };
    const svcUrl = LocalConfig.apiHash.dataset_stats;
    fetch(svcUrl, requestOptions)
      .then((res) => res.json())
      .then(
        (result) => {
          var tmpState = this.state;
          tmpState.response = result;
          tmpState.isLoaded = true;
          if (tmpState.response.status === 0){
            tmpState.dialog.status = true;
            tmpState.dialog.msg = tmpState.response.error;
          }
          this.setState(tmpState);
          console.log("Ajax response:", result);
        },
        (error) => {
          this.setState({
            isLoaded: true,
            error,
          });
        }
      );

  }



  render() {

    //if (!("response" in this.state)){
    //  return <Loadingicon/>
    //}
    //var statDict = this.state.response;
    //var n11 = statDict["bacteria"]["species_count"];
    //var n12 = statDict["bacteria"]["sample_count"];
    //var n21 = statDict["viruses"]["species_count"];
    //var n22 = statDict["viruses"]["sample_count"];
    //var n31 = statDict["fungi"]["species_count"];
    //var n32 = statDict["fungi"]["sample_count"];

    


    var s11 = {fontWeight:"bold", fontSize:"40px", color:"#464b6a",
        margin:"0px 0px 0px 5%", padding:"0px", border:"0px dashed red"};
    var s12 = {fontSize:"25px",  color:"#464b6a",
        margin:"10px 5% 0px 0px", padding:"0px", border:"0px dashed red"};
   

    var s21 = { width:"100%", height:"60px", 
        fontWeight:"bold",fontSize:"50px", color:"#464b6a", textAlign:"center",
        margin:"50px 0px 0px 0px", padding:"0px", border:"0px dashed red"};
    
    var s22 = { width:"100%", height:"40px", 
        fontWeight:"bold", fontSize:"25px",  color:"#464b6a", textAlign:"center",
        margin:"0px 0px 0px 0px", padding:"0px", border:"0px dashed red"};
    
    var s3 = {width:"40%", margin:"30px 30% 20px 30%", display:"none", padding:"0px", border:"0px dashed red"};
    
    var sLink = {textDecoration:"none", color:"#464b6a"};
    var rowStyle = {border:"1px solid", textAlign:"center"};

    //var statsCn = (
    //    <table style={{width:"100%"}}>
    //                    <tr style={rowStyle}><td></td><td>Species</td><td>Samples</td></tr>
    //                    <tr style={rowStyle}><td>Bacteria</td><td>{n11}</td><td>{n12}</td></tr>
    //                   <tr style={rowStyle}><td>Viruses</td><td>{n21}</td><td>{n22}</td></tr>
    //                    <tr style={rowStyle}><td>Fungi</td><td>{n31}</td><td>{n32}</td></tr>
    //    </table>);

    var statsCn = "";

    return (
        <div>
            <div className="leftblock" style={{width:"100%", height:"50px"}}>
                <div className="leftblock" style={s11}>ARGOS</div>
                <div className="rightblock" style={s12}>
                    <a href="https://data.argosdb.org/" style={sLink}>DATA</a>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <a href="https://github.com/FDA-ARGOS" style={sLink}>GITHUB</a>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <a href="https://www.fda.gov/emergency-preparedness-and-response/mcm-regulatory-science/expanding-next-generation-sequencing-tools-support-pandemic-preparedness-and-response" style={sLink}>ABOUT</a>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;        
                    <a style={sLink} href="https://hivelab.biochemistry.gwu.edu/wiki/Contact">CONTACT US</a>
                </div>
            </div>
            <div className="pagecn">
                <div className="bannerone">
                    <div className="bannertwo">
                        <div className="leftblock" style={s21}>Welcome to ARGOS</div>
                        <div className="leftblock" style={s22}>
                            The Regulatory-Grade Database for Infectious Disease Detection
                        </div>
                    </div>
                </div>
                
                <div className="leftblock" style={s3}>
                    <div className="leftblock" style={{width:"100%", fontSize:"30px", fontWeight:"bold",textAlign:"center"}}>
                        Database Statistics</div>
                    {statsCn}
                </div>

            </div>
        </div>
    ); 
      
    var stat_div = {display:"block", float:"left", width:"100%", padding:"0px", border:"1px dashed red"};
    var stat_tbl = {width:"60%", margin:"0% 20% 0% 20%", border:"1px dashed red"};
    return (
      <div className="argos-landing-page-v1">
        
        <img className="rectangle-icon3" alt=""/>
        <img className="ebola-image-icon3" alt="" src="/imglib/ebola-image@2x.png"/>
        <div className="white-bubble-div3"></div>
        <div className="welcome-to-argos3">Welcome to ARGOS</div>
        <div className="the-regulatory-grade-database6">
          <p className="the-regulatory-grade-database7">
            The Regulatory-Grade Database for Infectious Disease Detection
          </p>
        </div>

        <div className="group-div3">
          <div className="header-div3"></div>
          <div className="about-div2">
            <a href="https://www.fda.gov/emergency-preparedness-and-response/mcm-regulatory-science/expanding-next-generation-sequencing-tools-support-pandemic-preparedness-and-response"
            target="_blank"> ABOUT</a>
          </div>
          <div className="data-div2">
            <a href="https://data.argosdb.org" >DATA</a>
          </div>
          <div className="argos-div3">ARGOS</div>
          <div className="github-div2">
            <a className="github-a" href="https://github.com/FDA-ARGOS" target="_blank">GITHUB</a
        >
          </div>
        </div>


         <div style={stat_div}>
            <table style={stat_tbl}>
                <tr><td>aa</td><td>bb</td></tr>
                <tr><td>aa</td><td>bb</td></tr>
            </table>
        </div>


        <div className="footer-div3"><div className="rectangle-div6"></div></div>
        <div className="contact-us-div3">CONTACT US</div>
        <img className="icoutline-email-icon3" alt="" />
        <div className="rectangle-div7"></div>
        <img className="rectangle-icon4" alt="" />
        <div className="footer-div4"><div className="rectangle-div6"></div></div>
        <a href="https://hivelab.biochemistry.gwu.edu/wiki/Contact">
            <div className="contact-us-div4">CONTACT US</div>
            <img className="icoutline-email-icon4" alt="" src="/imglib/icoutlineemail.svg"/>
        </a>
        <img className="unnamed-2-icon6" alt="" src="/imglib/unnamed2@2x.png" />
        <img className="unnamed-1-icon3" alt="" src="/imglib/unnamed-1@2x.png"/>
        <img className="unnamed-2-icon7" alt="" src="/imglib/unnamed-2@2x.png"/>
      </div>
    );
  }
}

export default Homepage;
